<template>
  <div v-if="!hasPermission('List Place Insurance')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
      <Toolbar />
      <div class="container-xxl">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                <div class="d-flex align-items-center position-relative my-1">
                  <span class="svg-icon svg-icon-1 position-absolute ms-6">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                      <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                    </svg>
                  </span>
                  <input type="text" data-kt-user-table-filter="search" v-model="search"
                         class="form-control form-control-solid w-250px ps-14"
                         placeholder="Pesquisar ...">
                </div>
              </div>
              <div class="card-toolbar">
                <div class="col-md-6">
                  <button class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                          v-if="hasPermission('Store Place Insurance')"
                          title="Novo convênio" data-bs-target="#modal_store_insurance" @click="searchInsurance='';formStore.id_insurance='';formStoreErrors=[];formStore.exam_categories=[];loadAllCategories();">
                    <i class="bi bi-plus-lg"></i> Adicionar
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body py-4">
              <table class="table table-row-bordered gy-5">
                <thead>
                  <tr class="fw-bold fs-6 text-muted">
                    <th>Convênio</th>
                    <th>Apelido</th>
                    <th>Valor</th>
                    <th>Disp. Paciente?</th>
                    <th>Tabela repasse</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="insurance in insurancesFiltered">
                    <td>{{ insurance.code_ans }} - {{insurance.insurance_name}}</td>
                    <td>{{insurance.place_insurance.nick_name}}</td>
                    <td>R$ {{Number(insurance.place_insurance.value).toFixed(2).toString().replace(".", ",")??'0,00'}}</td>
                    <td>{{insurance.place_insurance.available_to_patient ? 'Sim' : 'Não'}}</td>
                    <td>{{ insuranceLinkedToPlan(insurance) ? '—' : transferTableLabel(insurance.place_insurance.id_transfer_table) }}</td>
                    <td class="text-center" style="min-width: 125px;">
                      <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                              v-if="hasPermission('Update Place Insurance')"
                              data-bs-toggle="modal"
                              data-bs-target="#modal_edit_insurance"
                              @click="formEditErrors=[];onClickBtnEdit(insurance);$nextTick(() => { console.log('Form edit after nextTick:', this.formEdit); })"
                              title="Editar Convênio">
                        <i class="bi bi-pencil-square"></i>
                      </button>
                      <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1" @click="deleteInsurance(insurance.id_insurance)"
                              v-if="hasPermission('Delete Place Insurance')"
                              data-bs-toggle="tooltip" title="Excluir Convênio">
                        <i class="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="modal fade" tabindex="-1" id="modal_store_insurance">
            <div class="modal-dialog modal-lg">
              <form method="post" @submit.prevent="submitFormStore">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Adicionar Convênio</h5>
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
                      <i class="bi bi-x-lg"></i>
                    </div>
                  </div>
                  <div class="modal-body">
                    <!-- Navegação por abas -->
                    <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#kt_modal_store_insurance_basic">
                          <i class="bi bi-info-circle me-2"></i>Informações Básicas
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#kt_modal_store_insurance_files">
                          <i class="bi bi-folder2-open me-2"></i>Documentos no agendamento
                        </a>
                      </li>
                    </ul>

                    <!-- Conteúdo das abas -->
                    <div class="tab-content" id="kt_modal_store_insurance_tab_content">
                      <!-- Aba: Informações Básicas -->
                      <div class="tab-pane fade show active" id="kt_modal_store_insurance_basic" role="tabpanel">
                        <div class="col-md-12">
                          <div class="mb-6">
                            <div class="d-flex align-items-center position-relative my-1">
                              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                                  <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                                </svg>
                              </span>
                              <input type="text" data-kt-user-table-filter="search" v-model="searchInsurance"
                                     class="form-control form-control-solid ps-14"
                                     placeholder="Pesquisar o convênio...">
                            </div>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-6">
                            <div class="mt-4">
                              <label for="id_insurance_store" class="required form-label">Selecione o Convênio</label>
                              <select class="form-control form-control-solid" id="id_insurance_store"
                                      size="5"  aria-label="Selecione o convênio" v-model="formStore.id_insurance" required>
                                <option :value="insurance.id_insurance" v-for="insurance in allInsurancesFiltered">
                                  {{ insurance.code_ans }} - {{ insurance.insurance_name }}
                                </option>
                              </select>
                            </div>
                            <small class="text-danger" v-if="formStoreErrors.id_insurance">{{ formStoreErrors.id_insurance[0] }}</small>
                          </div>
                        </div>
                        <div class="row mt-4 mb-6">
                          <div class="col-md-8">
                            <label for="nick_name_block_store" class="form-label required">Apelido</label>
                            <input type="text" class="form-control form-control-solid"
                                   id="nick_name_block_store" maxlength="30" v-model="formStore.nick_name" required>
                            <small class="text-danger" v-if="formStoreErrors.nick_name">{{ formStoreErrors.nick_name[0] }}</small>
                          </div>
                          <div class="col-md-4">
                            <label for="value_lock_store" class="form-label required">Valor da Consulta</label>
                            <input type="number" class="form-control form-control-solid"
                                   min="0.00" step="0.01"
                                   id="value_lock_store" v-model="formStore.value" required>
                            <small class="text-danger" v-if="formStoreErrors.value">{{ formStoreErrors.value[0] }}</small>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <label for="observation_block_store" class="form-label">Observação</label>
                            <textarea  type="text" class="form-control form-control-solid"
                                       id="observation_block_store" maxlength="255" rows="3" v-model="formStore.observation" >
                                  </textarea>
                            <small class="text-danger" v-if="formStoreErrors.observation">{{ formStoreErrors.observation[0] }}</small>
                          </div>
                          <div class="col-md-12 mt-4">
                            <label for="id_transfer_table_store" class="form-label">Tabela de repasse</label>
                            <select class="form-control form-control-solid" id="id_transfer_table_store"
                                    v-model="formStore.id_transfer_table">
                              <option :value="null">(nenhuma)</option>
                              <option v-for="t in transferTablesForInsurance" :key="t.id_transfer_table" :value="t.id_transfer_table">
                                {{ t.transfer_table_name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-12 mt-4">
                            <div class="mb-6">
                              <div class="row form-check form-switch">
                                <label class="form-check-label" for="sto_available_to_patient">
                                  Disponível para agendamento pelo paciente?</label>
                                <input class="form-check-input" type="checkbox" role="switch" id="sto_available_to_patient"
                                       v-model="formStore.available_to_patient">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Aba: Arquivos por Categoria -->
                      <div class="tab-pane fade" id="kt_modal_store_insurance_files" role="tabpanel">
                        <div class="mb-6">
                          <h6 class="fw-bold mb-3">Documentos solicitados no agendamento de Exames</h6>
                          
                          <!-- Lista de categorias configuradas -->
                          <div v-if="formStore.exam_categories && formStore.exam_categories.length > 0" class="mb-4">
                            <div v-for="(category, categoryIndex) in formStore.exam_categories" :key="categoryIndex" 
                                 class="border border-primary border-opacity-25 rounded-3 p-4 mb-4 shadow-sm">
                              <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="d-flex align-items-center">
                                  <i class="bi bi-folder2-open me-2 text-primary fs-4"></i>
                                  <div>
                                    <h6 class="fw-bold mb-0">{{ category.name }}</h6>
                                    <small class="text-muted">{{ category.description }}</small>
                                    <br>
                                    <small class="text-info">{{ category.files.length }} arquivo(s) configurado(s)</small>
                                  </div>
                                </div>
                              </div>
                              
                              <!-- Lista de arquivos da categoria - MELHORADA -->
                              <div v-if="category.files && category.files.length > 0" class="ms-4">
                                <div class="row g-2">
                                  <div v-for="(file, fileIndex) in category.files" :key="fileIndex" 
                                       class="col-md-6">
                                    <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded border mb-2">
                                      <div class="d-flex align-items-center">
                                        <i class="bi bi-file-earmark-text me-2 text-primary"></i>
                                        <div>
                                          <div class="fw-semibold">{{ file.name }}</div>
                                          <span :class="file.is_required ? 'badge badge-danger' : 'badge badge-success'" 
                                                class="badge badge-sm">
                                            {{ file.is_required ? 'Obrigatório' : 'Opcional' }}
                                          </span>
                                        </div>
                                      </div>
                                      <button type="button" class="btn btn-sm btn-outline-danger" 
                                              @click="removeFileFromCategory(categoryIndex, fileIndex)"
                                              title="Remover arquivo">
                                        <i class="bi bi-x"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              <!-- Divider -->
                              <div class="border-top my-4"></div>
                              
                              <!-- Formulário para adicionar arquivo à categoria -->
                              <div class="ms-4 mt-3">
                                <div class="row g-2">
                                  <div class="col-md-6">
                                    <input type="text" class="form-control form-control-sm" 
                                           v-model="category.newFile.name" 
                                           placeholder="Nome do arquivo (ex: Pedido médico, Guia)">
                                  </div>
                                  <div class="col-md-3">
                                    <select class="form-control form-control-sm" 
                                            v-model="category.newFile.is_required">
                                      <option :value="true">Obrigatório</option>
                                      <option :value="false">Opcional</option>
                                    </select>
                                  </div>
                                  <div class="col-md-3">
                                    <button type="button" class="btn btn-sm btn-outline-primary w-100" 
                                            @click="addFileToCategory(categoryIndex)"
                                            :disabled="!category.newFile.name.trim()">
                                      <i class="bi bi-plus me-1"></i>Adicionar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Informação sobre categorias automáticas -->
                          <div class="alert alert-info">
                            <i class="bi bi-info-circle me-2"></i>
                            <strong>Todas as categorias de exame estão disponíveis automaticamente.</strong>
                            <br>
                            <small>Configure os arquivos obrigatórios/opcionais para cada categoria conforme necessário.</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                    <button type="submit" class="btn btn-primary">Cadastrar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div class="modal fade" tabindex="-1" id="modal_edit_insurance">
            <div class="modal-dialog modal-lg">
              <form method="post" @submit.prevent="submitFormEdit">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Editar Convênio</h5>
                    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
                      <i class="bi bi-x-lg"></i>
                    </div>
                  </div>
                  <div class="modal-body">
                    <!-- Navegação por abas -->
                    <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#kt_modal_edit_insurance_basic">
                          <i class="bi bi-info-circle me-2"></i>Informações Básicas
                        </a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#kt_modal_edit_insurance_files">
                          <i class="bi bi-folder2-open me-2"></i>Documentos no agendamento
                        </a>
                      </li>
                    </ul>

                    <!-- Conteúdo das abas -->
                    <div class="tab-content" id="kt_modal_edit_insurance_tab_content">
                      <!-- Aba: Informações Básicas -->
                      <div class="tab-pane fade show active" id="kt_modal_edit_insurance_basic" role="tabpanel">
                        <div class="col-md-12">
                          <div class="mb-6">
                            <label for="insurance_name_block_edit" class="form-label required">Convênio</label>
                            <input type="text" class="form-control form-control-solid"
                                   disabled
                                   id="insurance_name_block_edit" v-model="formEdit.insurance_name">
                          </div>
                        </div>
                        <div class="row mb-6">
                          <div class="col-md-8">
                            <label for="nick_name_block_edit" class="form-label required">Apelido</label>
                            <input type="text" class="form-control form-control-solid"
                                   id="nick_name_block_edit" maxlength="30" v-model="formEdit.nick_name" required>
                            <small class="text-danger" v-if="formEditErrors.nick_name">{{ formEditErrors.nick_name[0] }}</small>
                          </div>
                          <div class="col-md-4">
                            <label for="value_lock_edit" class="form-label required">Valor da Consulta</label>
                            <input type="number" class="form-control form-control-solid"
                                   min="0.00" step="0.01"
                                   id="value_lock_edit" v-model="formEdit.value" required>
                            <small class="text-danger" v-if="formEditErrors.value">{{ formEditErrors.value[0] }}</small>
                          </div>
                        </div>
                        <div class="col-md-12">
                          <div class="mb-6">
                            <label for="observation_block_edit" class="form-label">Observação</label>
                            <textarea  type="text" class="form-control form-control-solid"
                                       id="observation_block_edit" maxlength="255" rows="3" v-model="formEdit.observation">
                                  </textarea>
                          </div>

                          <div class="col-md-12 mt-4">
                            <label for="id_transfer_table_edit" class="form-label">Tabela de repasse</label>
                            <select class="form-control form-control-solid" id="id_transfer_table_edit"
                                    v-model="formEdit.id_transfer_table">
                              <option :value="null">(nenhuma)</option>
                              <option v-for="t in transferTablesForInsurance" :key="'e'+t.id_transfer_table" :value="t.id_transfer_table">
                                {{ t.transfer_table_name }}
                              </option>
                            </select>
                          </div>
                          <div class="col-md-12 mt-4">
                            <div class="mb-6">
                              <div class="row form-check form-switch">
                                <label class="form-check-label" for="available_to_patient">
                                  Disponível para agendamento pelo paciente?</label>
                                <input class="form-check-input" type="checkbox" role="switch" id="available_to_patient"
                                       v-model="formEdit.available_to_patient">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Aba: Arquivos por Categoria -->
                      <div class="tab-pane fade" id="kt_modal_edit_insurance_files" role="tabpanel">
                        <div class="mb-6">
                          <h6 class="fw-bold mb-3">Documentos solicitados no agendamento de Exames</h6>
                          
                          <!-- Lista de categorias configuradas -->
                          <div v-if="formEdit.exam_categories && formEdit.exam_categories.length > 0" class="mb-4">
                            <div v-for="(category, categoryIndex) in formEdit.exam_categories" :key="categoryIndex" 
                                 class="border border-primary border-opacity-25 rounded-3 p-4 mb-4 shadow-sm">
                              <div class="d-flex align-items-center justify-content-between mb-3">
                                <div class="d-flex align-items-center">
                                  <i class="bi bi-folder2-open me-2 text-primary fs-4"></i>
                                  <div>
                                    <h6 class="fw-bold mb-0">{{ category.name }}</h6>
                                    <small class="text-muted">{{ category.description }}</small>
                                    <br>
                                    <small class="text-info">{{ category.files.length }} arquivo(s) configurado(s)</small>
                                  </div>
                                </div>
                              </div>
                              
                              <!-- Lista de arquivos da categoria - MELHORADA -->
                              <div v-if="category.files && category.files.length > 0" class="ms-4">
                                <div class="row g-2">
                                  <div v-for="(file, fileIndex) in category.files" :key="fileIndex" 
                                       class="col-md-6">
                                    <div class="d-flex align-items-center justify-content-between p-3 bg-light rounded border mb-2">
                                      <div class="d-flex align-items-center">
                                        <i class="bi bi-file-earmark-text me-2 text-primary"></i>
                                        <div>
                                          <div class="fw-semibold">{{ file.name }}</div>
                                          <span :class="file.is_required ? 'badge badge-danger' : 'badge badge-success'" 
                                                class="badge badge-sm">
                                            {{ file.is_required ? 'Obrigatório' : 'Opcional' }}
                                          </span>
                                        </div>
                                      </div>
                                      <button type="button" class="btn btn-sm btn-outline-danger" 
                                              @click="removeFileFromCategoryEdit(categoryIndex, fileIndex)"
                                              title="Remover arquivo">
                                        <i class="bi bi-x"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              
                              <!-- Divider -->
                              <div class="border-top my-4"></div>
                              
                              <!-- Formulário para adicionar arquivo à categoria -->
                              <div class="ms-4 mt-3">
                                <div class="row g-2">
                                  <div class="col-md-6">
                                    <input type="text" class="form-control form-control-sm" 
                                           v-model="category.newFile.name" 
                                           placeholder="Nome do arquivo (ex: Pedido médico, Guia)">
                                  </div>
                                  <div class="col-md-3">
                                    <select class="form-control form-control-sm" 
                                            v-model="category.newFile.is_required">
                                      <option :value="true">Obrigatório</option>
                                      <option :value="false">Opcional</option>
                                    </select>
                                  </div>
                                  <div class="col-md-3">
                                    <button type="button" class="btn btn-sm btn-outline-primary w-100" 
                                            @click="addFileToCategoryEdit(categoryIndex)"
                                            :disabled="!category.newFile.name.trim()">
                                      <i class="bi bi-plus me-1"></i>Adicionar
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                          <!-- Informação sobre categorias automáticas -->
                          <div class="alert alert-info">
                            <i class="bi bi-info-circle me-2"></i>
                            <strong>Todas as categorias de exame estão disponíveis automaticamente.</strong>
                            <br>
                            <small>Configure os arquivos obrigatórios/opcionais para cada categoria conforme necessário.</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                    <button type="submit" class="btn btn-primary">Salvar</button>
                  </div>
                </div>
              </form>
            </div>
          </div>

      </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";

export default {
  name: "Insurance",
    components: {
        Toolbar,
    },
  data() {
    return {
      search: '',
      insurances: [],
      allInsurances: [],
      searchInsurance: '',
      specialtyGroups: [],
      transferTables: [],
      formStore: {
        id_insurance: '',
        observation: '',
        available_to_patient: '',
        nick_name: '',
        value: '',
        id_transfer_table: null,
        exam_categories: [],
      },
      formStoreErrors: [],
      formEdit: {
        id_insurance: '',
        id_plan: null,
        insurance_name: '',
        observation: '',
        available_to_patient: false,
        nick_name: '',
        value: '',
        id_transfer_table: null,
        exam_categories: [],
      },
      formEditErrors: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    insurancesFiltered() {
      return this.insurances.filter(insurance => {
        return insurance.insurance_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    allInsurancesFiltered() {
      return this.allInsurances.filter(insurance => {
        return insurance.insurance_name.toLowerCase().includes(this.searchInsurance.toLowerCase());
      });
    },
    /** Tabelas de repasse elegíveis a convênios (exclui Particular). */
    transferTablesForInsurance() {
      return this.transferTables || [];
    },
    storeSelectedInsurance() {
      if (!this.formStore.id_insurance) {
        return null;
      }
      return this.allInsurances.find(
        (i) => String(i.id_insurance) === String(this.formStore.id_insurance),
      ) ?? null;
    },
  },
  mounted() {
      this.loadAllInsurances();
      this.loadSpecialtyGroups();
      this.loadTransferTables().then(() => this.loadInsurances());
      
      // Adicionar listener para resetar formulário quando modal for fechado
      const editModal = document.getElementById('modal_edit_insurance');
      if (editModal) {
        editModal.addEventListener('hidden.bs.modal', () => {
          this.resetFormEdit();
        });
      }
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    insuranceLinkedToPlan(insurance) {
      return insurance != null && insurance.id_plan != null && insurance.id_plan !== '';
    },
    loadAllInsurances() {
      http.get(`/insurances`).then((response) => {
        this.allInsurances = response.data;
      });
    },
    loadInsurances() {
      http.get(`/places/${this.place.id_place}/insurances`).then((response) => {
        this.insurances = response.data;
      });
    },
    loadTransferTables() {
      return http.get(`/places/${this.place.id_place}/transfer-tables`).then((response) => {
        this.transferTables = response.data.data || [];
      }).catch(() => {
        this.transferTables = [];
      });
    },
    transferTableLabel(idTransferTable) {
      if (!idTransferTable) return '—';
      const t = this.transferTables.find(x => x.id_transfer_table === idTransferTable);
      return t ? t.transfer_table_name : `#${idTransferTable}`;
    },
    loadSpecialtyGroups() {
      http.get(`/specialty-groups`, {params: {kind_exam: true}}).then((response) => {
        this.specialtyGroups = response.data;
        this.loadAllCategories();
      });
    },
    loadAllCategories() {
      this.formStore.exam_categories = this.specialtyGroups.map(group => ({
        id_spec_group: group.id_spec_group,
        name: group.spec_group_name,
        description: group.spec_group_description,
        files: [],
        newFile: {
          name: '',
          is_required: true,
        }
      }));
    },
    submitFormStore() {
      this.formStoreErrors = [];

      // Achatar files -> exam_categories no formato da API
      const examCategoriesPayload = (this.formStore.exam_categories || []).flatMap(category => {
        return (category.files || []).map(file => ({
          id_spec_group: category.id_spec_group,
          name: file.name,
          required: !!file.is_required,
        }));
      });

      const payload = {
        id_insurance: this.formStore.id_insurance,
        observation: this.formStore.observation,
        available_to_patient: this.formStore.available_to_patient,
        nick_name: this.formStore.nick_name,
        value: this.formStore.value,
        id_transfer_table: this.formStore.id_transfer_table,
        exam_categories: examCategoriesPayload,
      };

      http.post(`/places/${this.place.id_place}/insurances`, payload).then(_ => {
        this.loadInsurances();
        Alert.toastSuccess("Convênio cadastrado com sucesso.");
        this.formStore = {
          id_insurance: '',
          observation: '',
          available_to_patient: '',
          nick_name: '',
          value: '',
          id_transfer_table: null,
          exam_categories: [],
        };


        this.loadAllCategories();
        bootstrap.Modal.getInstance(document.getElementById('modal_store_insurance')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message??e.response.data);
        if (e.response.data.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      });
    },
    submitFormEdit() {
      console.log('Form edit data before submit:', this.formEdit);

      // Achatar files -> exam_categories no formato da API
      const examCategoriesPayload = (this.formEdit.exam_categories || []).flatMap(category => {
        return (category.files || []).map(file => ({
          id_spec_group: category.id_spec_group,
          name: file.name,
          required: !!file.is_required,
        }));
      });

      const place_insurance = {
        id_insurance: this.formEdit.id_insurance,
        observation: this.formEdit.observation,
        available_to_patient: this.formEdit.available_to_patient,
        nick_name: this.formEdit.nick_name,
        value: this.formEdit.value,
        id_transfer_table: this.formEdit.id_transfer_table,
        exam_categories: examCategoriesPayload,
      };

      console.log('Data being sent to API:', place_insurance);

      http.put(`/places/${this.place.id_place}/insurances/${this.formEdit.id_insurance}`, place_insurance).then(() => {
        this.loadInsurances();
        Alert.toastSuccess("Convênio atualizado com sucesso.");

        bootstrap.Modal.getInstance(document.getElementById('modal_edit_insurance')).toggle();
      }).catch(e => {
        console.error('Error updating insurance:', e);
        Alert.toastError(e.response.data.message??e.response.data);
        if (e.response.data.errors) {
          this.formEditErrors = e.response.data.errors;
        }
      });
    },
    onClickBtnEdit(insurance) {
      console.log('Insurance data received:', insurance);
      console.log('Place insurance data:', insurance.place_insurance);
      
      this.formEdit.id_insurance = insurance.id_insurance;
      this.formEdit.id_plan = insurance.id_plan ?? null;
      this.formEdit.insurance_name = insurance.insurance_name;
      this.formEdit.observation = insurance.place_insurance.observation;
      this.formEdit.available_to_patient = insurance.place_insurance.available_to_patient;
      this.formEdit.nick_name = insurance.place_insurance.nick_name;
      this.formEdit.value = insurance.place_insurance.value;
      this.formEdit.id_transfer_table = insurance.place_insurance.id_transfer_table ?? null;
      
      console.log('Form edit after mapping:', this.formEdit);
      
      // Carregar categorias de exames existentes
      this.loadAllCategoriesForEdit(insurance.place_insurance.exam_categories);
    },
    loadAllCategoriesForEdit(existingCategories = []) {
      console.log('Existing categories from backend:', existingCategories);
      console.log('Specialty groups:', this.specialtyGroups);
      
      // Se não há categorias existentes, carregar todas vazias
      if (!existingCategories || existingCategories.length === 0) {
        this.formEdit.exam_categories = this.specialtyGroups.map(group => ({
          id_spec_group: group.id_spec_group,
          name: group.spec_group_name,
          description: group.spec_group_description,
          files: [],
          newFile: {
            name: '',
            is_required: true,
          }
        }));
        console.log('No existing categories, loaded empty categories:', this.formEdit.exam_categories);
        return;
      }
      
      // Mapear categorias existentes por id_spec_group e transformar itens em files
      const existingByGroup = {};
      existingCategories.forEach(cat => {
        if (!existingByGroup[cat.id_spec_group]) {
          existingByGroup[cat.id_spec_group] = {
            id_spec_group: cat.id_spec_group,
            name: cat.name,
            files: []
          };
        }
        existingByGroup[cat.id_spec_group].files.push({
          name: cat.name,
          is_required: !!cat.required,
        });
      });
      
      console.log('Grouped existing categories:', existingByGroup);
      
      this.formEdit.exam_categories = this.specialtyGroups.map(group => {
        const existing = existingByGroup[group.id_spec_group];
        
        console.log(`Processing group ${group.spec_group_name} (ID: ${group.id_spec_group}), existing:`, existing);
        
        return {
          id_spec_group: group.id_spec_group,
          name: group.spec_group_name,
          description: group.spec_group_description,
          files: existing ? [...existing.files] : [],
          newFile: {
            name: '',
            is_required: true,
          }
        };
      });
      
      console.log('Final formEdit.exam_categories:', this.formEdit.exam_categories);
    },
    deleteInsurance(insuranceId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o convênio?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/insurances/${insuranceId}`).then(_ => {
            this.loadInsurances();
            Alert.toastSuccess("Convênio excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    
    // Métodos para gerenciar arquivos das categorias
    
    addFileToCategory(categoryIndex) {
      const category = this.formStore.exam_categories[categoryIndex];
      if (category.newFile.name.trim()) {
        category.files.push({
          name: category.newFile.name.trim(),
          is_required: category.newFile.is_required
        });
        category.newFile = {
          name: '',
          is_required: true,
        };
      }
    },
    
    removeFileFromCategory(categoryIndex, fileIndex) {
      this.formStore.exam_categories[categoryIndex].files.splice(fileIndex, 1);
    },
    
    // Métodos para edição de arquivos das categorias
    
    addFileToCategoryEdit(categoryIndex) {
      const category = this.formEdit.exam_categories[categoryIndex];
      if (category.newFile.name.trim()) {
        category.files.push({
          name: category.newFile.name.trim(),
          is_required: category.newFile.is_required
        });
        category.newFile = {
          name: '',
          is_required: true,
        };
      }
    },
    
    removeFileFromCategoryEdit(categoryIndex, fileIndex) {
      this.formEdit.exam_categories[categoryIndex].files.splice(fileIndex, 1);
    },
    
    resetFormEdit() {
      this.formEdit = {
        id_insurance: '',
        id_plan: null,
        insurance_name: '',
        observation: '',
        available_to_patient: false,
        nick_name: '',
        value: '',
        id_transfer_table: null,
        exam_categories: [],
      };
      this.formEditErrors = [];
    },

  }
}
</script>

<style scoped>

</style>